import { Sprite, Text } from 'pixi.js';

import { Shared } from '../App';
import { Game } from '../game/Game';
import { Widget } from './Widget';

export class TimerDisplayWidget extends Widget
{
    public game: Game;
    public base!: Sprite;
    public label!: Text;

    constructor(game: Game)
    {
        super();
        this.game = game;
    }

    protected async build(): Promise<void>
    {
        this.base = Sprite.from(Shared.assets.getTexture('icon-timer'));
        this.base.scale.set(0.8);
        this.base.anchor.set(0.5);
        this.view.addChild(this.base);

        this.label = new Text(`00:00:00`, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
            align: 'center',
            fontSize: 32,
        });
        this.label.anchor.y = 0.5;
        this.label.y = 2;
        this.label.x = 40;
        this.view.addChild(this.label);
    }

    public setDisplay(val: string): void
    {
        this.label.text = val;
    }
}
